import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api';

export const ProgressionView = ({ studentId }) => {
  const { data, isError } = useQuery({ enabled: !!studentId, retry: false, queryKey: ['progression', studentId],
    queryFn: () => api.get(`/gb/progression/${studentId}`).then((r) => r.data) });
  if (isError || !data) return null;
  const reg = data.registerable_next_term || [];
  const blocked = data.blocked_by_prereqs || [];
  const inprog = data.in_progress || [];
  if (!data.audits?.length && !data.standing && data.cumulative_gpa == null && !reg.length && !blocked.length && !inprog.length) return null;
  return (
    <div className="mt-4 border-t border-slate-100 pt-3" data-testid={`progression-${studentId}`}>
      <div className="flex items-center gap-3 mb-2 text-sm flex-wrap">
        {data.standing && <span className="text-[11px] px-2 py-0.5 rounded-full bg-slate-900 text-white capitalize" data-testid="progression-standing">{data.standing}</span>}
        {data.cumulative_gpa != null && <span className="text-slate-600">Cumulative GPA <b data-testid="progression-gpa">{data.cumulative_gpa}</b></span>}
      </div>
      {inprog.length > 0 && (
        <>
          <p className="font-mono-label text-[10px] uppercase text-slate-400 mb-1">Currently in progress</p>
          <div className="flex gap-1.5 flex-wrap mb-2" data-testid="progression-inprogress">
            {inprog.map((r, i) => (
              <span key={`${r.course_code}-${i}`} className="text-[11px] px-2 py-0.5 rounded-full border border-orange-300 bg-orange-50 text-orange-700">{r.course_code} · {r.status}</span>
            ))}
          </div>
        </>
      )}
      <p className="font-mono-label text-[10px] uppercase text-slate-400 mb-1">You can register for next term</p>
      <div className="flex gap-1.5 flex-wrap mb-2" data-testid="progression-registerable">
        {reg.map((r) => (
          <span key={r.code} className="text-[11px] px-2 py-0.5 rounded-full border border-green-300 bg-green-50 text-green-700">{r.code} · {r.credits} cr · {r.category}</span>
        ))}
        {reg.length === 0 && <span className="text-xs text-slate-400">Nothing new right now - everything is either done, in progress, or waiting on prerequisites.</span>}
      </div>
      {blocked.length > 0 && (
        <>
          <p className="font-mono-label text-[10px] uppercase text-slate-400 mb-1">Blocked until prerequisites pass</p>
          <div className="flex gap-1.5 flex-wrap" data-testid="progression-blocked">
            {blocked.map((r) => (
              <span key={r.code} className="text-[11px] px-2 py-0.5 rounded-full border border-amber-300 bg-amber-50 text-amber-700">{r.code} needs {(r.missing_prereqs || []).join(', ')}</span>
            ))}
          </div>
        </>
      )}
    </div>
  );
};
